// File excluded from token migration due to custom illustration
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N300 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EditBar = styled.div({
	height: '17.33px',
	display: 'flex',
	alignItems: 'center',
	paddingLeft: token('space.050', '4px'),
	borderBottom: `1px solid ${token('color.background.accent.gray.subtlest', '#F1F2F4')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ConfluenceIconGroup = styled.div({
	paddingRight: token('space.025', '2px'),
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > *not(:last-child)': {
		paddingRight: token('space.025', '2px'),
	},
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ConfluenceIcon = styled.img({
	height: '11.33px',
	width: '11.33px',
	marginRight: token('space.025', '2px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconGroup = styled.div({
	display: 'flex',
	alignItems: 'center',
	position: 'relative',
	padding: `${token('space.0', '0px')} ${token('space.025', '2px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& > *:not(:first-child)': {
		marginLeft: token('space.025', '2px'),
	},
	'&::before': {
		content: '""',
		position: 'absolute',
		left: 0,
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
		top: '25%',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
		bottom: '25%',
		borderLeft: `1px solid ${token('color.background.accent.gray.subtler', N300)}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconChevronGroup = styled.div({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& > *:not(:first-child)': {
		marginLeft: token('space.negative.025', '-2px'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconSizeAdjuster = styled.div({
	display: 'flex',
	color: token('color.text.subtlest', '#626F86'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > span': {
		width: '8.5px',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TextColorIcon = styled.img({
	width: '12px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AvatarContainer = styled.div({
	flex: '1 1 auto',
	height: '11.33px',
	position: 'relative',
	marginBottom: token('space.025', '2px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Avatar = styled.div<{
	right: string;
	zIndex: number;
	src: string;
}>({
	// this is an illustration and we don't want to tokenize dimensions
	width: '11.33px',
	height: '11.33px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundImage: (props) => `url(${props.src})`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props) =>
		!props.src && token('color.background.neutral', 'rgba(9, 30, 66, 0.04)'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: (props) => !props.src && token('color.text.subtle', '#44546F'),
	backgroundSize: 'contain',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	right: (props) => props.right,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	zIndex: (props) => props.zIndex,
	position: 'absolute',
	borderRadius: '20px',
	border: `1px solid ${token('elevation.surface', '#FFFFFF')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	fontWeight: (props) => (!props.src ? '400' : '600'),
	fontSize: token('space.075'),
	lineHeight: '20px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	opacity: 1,
	transition: 'background-color 0.2s ease-in',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EditorItemSkeleton = styled.div<{
	color?: string;
	width: number;
	marginRight?: number;
}>({
	// this is an illustration and we don't want to tokenize dimensions
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	width: (props) => `${props.width}px`,
	height: '5.67px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	background: (props) =>
		props.color ? `${props.color}` : token('color.background.accent.gray.subtler', N300),
	borderRadius: '2px',
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginRight: (props) =>
		props.marginRight ? `${props.marginRight}px` : token('space.050', '4px'),
});
